import { Link } from "react-router-dom";
import { testimonials } from "@/mocks/site";

export default function BrandSection() {
  return (
    <section
      className="w-full border-t border-background-200/70 bg-background-100/60 px-4 py-14 md:px-8 md:py-20"
      aria-labelledby="brand-title"
    >
      <div className="mb-10 max-w-2xl">
        <p className="text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
          Reader Voices
        </p>
        <h2
          id="brand-title"
          className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl"
        >
          读者的真实反馈
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600">
          从通勤路上的快速浏览，到睡前的瓜单打卡，我们想做的是一份克制、可信、读起来不累的内容。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {testimonials.map((item) => (
          <figure
            key={item.name}
            className="flex h-full flex-col justify-between rounded-lg border border-background-200/80 bg-background-50 p-5"
          >
            <div className="flex h-7 items-center gap-0.5 text-accent-500">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-sm"></i>
              ))}
            </div>
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
              {item.text}
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/80 pt-4">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-semibold text-secondary-800">
                {item.name.slice(0, 1)}
              </span>
              <span>
                <span className="block text-sm font-medium text-foreground-900">
                  {item.name}
                </span>
                <span className="block text-xs text-foreground-500">{item.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>

      <div className="mt-10 flex justify-center">
        <Link
          to="/about"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/80 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-information-line"></i>
          了解我们的内容原则
        </Link>
      </div>
    </section>
  );
}